import { useSelector } from "react-redux";


const useAuthRole = () => {
  const { user, token } = useSelector((state) => state.auth);


  const isAuthenticated = !!token && !!user;

  const isAdmin = isAuthenticated && user?.role === "admin";

  
  const hasRole = (requiredRole) => {
    return isAuthenticated && user?.role === requiredRole;
  };

 
  const hasActiveSubscription =
    isAuthenticated &&
    user?.subscriptions?.some((sub) => sub.isActive === true);

  
  const hasPlanAccess = (planType) => {
    return (
      isAuthenticated &&
      user?.subscriptions?.some(
        (sub) => sub.isActive && sub.plan?.type === planType
      )
    );
  };


  const hasPermission = (permission) => {
    if (!isAuthenticated) return false;

    return user.subscriptions?.some(
      (sub) => sub.isActive && sub.plan?.permissions?.includes(permission)
    );
  };


  const hasProAccess = hasPlanAccess("PRO_ACCESS");

  return {
    user,
    token,
    isAuthenticated,
    isAdmin,
    hasRole,
    hasActiveSubscription,
    hasPlanAccess,
    hasPermission,
    hasProAccess,
  };
};

export default useAuthRole;
